<template>
    <div>

    <section class="about d-flex align-items-center">
        <div class="container py-5">
            
        </div>
    </section>

    <section class="py-4">
        <div class="container">
            <div class="p-4">
                <h5 class="fw-bold mb-2"><span style="color:var(--brand)">ABOUT US</span></h5>
                <div class="d-flex justify-content-start">
                    <p><strong>{{ COMPANYFULLNAME }}</strong> is a <strong>Canadian-owned civil engineering firm</strong> specializing in <strong>land development projects</strong> across Canada. Our portfolio includes <strong>commercial</strong>, <strong>industrial</strong>, <strong>multi-family</strong>, <strong>single-family</strong>, and <strong>redevelopment</strong> developments. Serving Alberta, British Columbia, Saskatchewan, Ontario and Manitoba.</p>
                </div>
                <div class="d-flex justify-content-start">
                    <p>Backed by a team of experienced professionals, {{ COMPANYFULLNAME }} delivers <strong>innovative, practical, and cost-effective</strong> engineering solutions tailored to the unique needs of each project. We understand that every site presents distinct <strong>logistical</strong>, <strong>environmental</strong>, and <strong>regulatory challenges</strong>, and we tailor our designs to achieve optimal results.</p>
                </div>
                <div class="d-flex justify-content-start">
                    <p>Our mission is to provide <strong>customized engineering services</strong> that maximize <strong>value</strong>, <strong>functionality</strong>, and <strong>efficiency</strong> for investors, developers, and end users.</p>
                </div>                
            </div>

            <hr class="hr-soft">

            <div class="p-4">
                <h5 class="fw-bold mb-2">TEAM</h5>                
                <div class="d-flex justify-content-start" style="padding-top: 18px;">                       
                    <p><span style="color:var(--brand)">Bin (Robin) Li</span>&nbsp;&nbsp;P.Eng President</p>                        
                </div>                    
                <div class="d-flex justify-content-start">
                    <p>Mr. Li provides overall strategic direction and technical oversight for {{ COMPANYFULLNAME }}, with a focus on <strong>innovative engineering design, project coordination, and municipal approvals</strong>.</p>                    
                </div>                     
                <div class="d-flex justify-content-start">                    
                    <p>He began his engineering career with the <strong>Shanghai Postal and Telecommunication Design Institute (SPTDI)</strong>, progressing from <strong>Junior Structural Engineer</strong> to <strong>Lead Engineer</strong> after earning his degree from <strong>TongJi University</strong> in 1992. His eight years in structural engineering broadened his expertise across <strong>architecture</strong>, <strong>mechanical/electrical systems</strong>, and <strong>urban planning</strong>.</p>
                </div>
                <div class="d-flex justify-content-start">
                    <p>After relocating to Calgary in 2000, Mr. Li joined <strong>Kellam Berg Engineering & Surveyors Ltd.</strong>, advancing from <strong>Draftsperson</strong> to <strong>Project Manager</strong>. From 2004 to 2007, he was extensively involved in <strong>engineering design</strong>, <strong>city approvals</strong>, <strong>client liaison</strong>, and <strong>coordination</strong>.</p>
                </div>
                <div class="d-flex justify-content-start">
                    <p>Mr. Li is a <strong>licensed Professional Engineer (P.Eng.)</strong> in <strong>Alberta, British Columbia, Saskatchewan, Manitoba, and Ontario</strong>, and remains committed to advancing innovative land development design throughout his career.</p>
                </div>

                <div class="d-flex justify-content-start" style="padding-top: 18px;">
                    <p><span style="color:var(--brand)">Jacky Wang</span> &nbsp;&nbsp;M. Finance, B.Sc. – Project Coordinator</p>
                </div>
                <div class="d-flex justify-content-start">
                    <p>Mr. Wang has been with <strong>{{ COMPANYFULLNAME }}</strong> since 2012. He is responsible for <strong>project coordination</strong>, ensuring that all design, review, and construction processes align with client objectives and regulatory timelines.</p>
                </div>
                <div class="d-flex justify-content-start">
                    <p>His role focuses on <strong>maintaining quality standards</strong>, managing schedules, and supporting efficient communication between clients, contractors, and regulatory authorities.</p>
                </div>

                <div class="d-flex justify-content-start" style="padding-top: 18px;">
                    <p><span style="color:var(--brand)">Charlie Chai</span> &nbsp;&nbsp;P.Eng. – Project Engineer</p>
                </div>
                <div class="d-flex justify-content-start">
                    <p>Mr. Chai joined <strong>{{ COMPANYFULLNAME }}</strong> in 2023 and currently leads <strong>project design</strong> and <strong>coordination with clients and approval authorities</strong>.</p>
                </div>
                <div class="d-flex justify-content-start">
                    <p>A graduate of <strong>TongJi University(2008)</strong>, Mr. Chai has over <strong>15 years of experience</strong> in structural engineering, during which he advanced from Junior Engineer to Lead Engineer. His expertise extends across <strong>architecture</strong>, <strong>mechanical/electrical systems</strong>, and <strong>urban planning</strong>, enabling a multidisciplinary approach to engineering design.</p>
                </div>
            </div>

            <!-- Team structure block (appended) -->
            <div class="p-4">
                <h5 class="fw-bold mb-2">Team Structure</h5>
                <p>
                    To provide exceptional service, <strong>{{ COMPANYFULLNAME }}</strong> maintains a <strong>skilled and well-balanced technical team</strong>, including:
                </p>
                <ul class="team-structure-list">
                    <li>2 Professional Engineers (P.Eng.)</li>
                    <li>2 Engineers-in-Training (EITs)</li>
                    <li>7 Draftspersons / Technicians</li>
                    <li>1 Field Inspector</li>
                    <li>2 Specialized Offsite Contractors</li>
                    <li>1 IT Support Specialist / Software Developer</li>
                </ul>
                <p>
                    This structure enables a <strong>comprehensive and collaborative approach</strong> to every project, ensuring design quality, schedule adherence, and coordination from concept through completion.
                </p>
            </div>

        </div>
    </section>
 
    </div>
</template>


<script setup>

import {COMPANYFULLNAME} from '@/constants';


</script>


<style scoped>
/* Reduce vertical spacing between ABOUT US and TEAM */
.about .p-4 {
  padding-top: 0.75rem;    /* default p-4 is large, reduce top padding */
  padding-bottom: 0.75rem; /* reduce bottom padding */
}

/* Decrease top/bottom spacing for hr */
.hr-soft {
  margin: 0.5rem 0;
  border: 0;
  height: 1px;
  background: rgba(255,255,255,0.03);
}

/* When hr is immediately followed by .p-4 (the TEAM block), reduce top padding */
.hr-soft + .p-4 {
  padding-top: 0.5rem;
}

/* Tweak heading bottom margin to make title and body more compact */
h5.fw-bold {
  margin-bottom: 0.5rem;
}

/* Team structure list styling to match page look */
.team-structure-list {
  margin: 0.5rem 0 0.75rem 1.25rem;
  padding: 0;
  list-style: disc;
  color: rgba(255,255,255,0.95);
}
.team-structure-list li {
  margin: 0.4rem 0;
  line-height: 1.5;
  font-size: 0.98rem;
}

/* Slightly larger spacing on very small screens */
@media (max-width: 576px) {
  .about .p-4 { padding-top: 0.6rem; padding-bottom: 0.6rem; }
  .hr-soft { margin: 0.4rem 0; }
}
</style>